// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.run-payroll-container {
  padding: 10px;
  background-color: #f8f9fa;
  /* min-height: 100vh; */
}

.payroll-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin-bottom: 10px; */
}

.payroll-filters {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 10px;
}

.filter-select {
  padding: 3px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
}

.primary-btn-payroll, .success-btn-payroll { 
    background-color: rgb(116, 197, 167);
    color: white;
    padding: 4px 16px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    height: 30px;
    margin-top: 3px;
}

.primary-btn-payroll:hover ,.success-btn-payroll:hover {
  background-color: rgb(93, 159, 135);
  color: black;
}

/* Table Styles */
.payroll-table-wrapper {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  overflow-x: auto;
}

.payroll-table {
  width: 100%;
  border-collapse: collapse;
}

.payroll-table th, .payroll-table td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.payroll-table th {
  background-color: #f9fafb;
  font-weight: 600;
  color: #374151;
}

.text-right { text-align: right; }
.text-center { text-align: center; }
.text-red { color: #dc2626; }
.font-bold { font-weight: 700; }

.view-btn {
  background: none;
  border: 1px solid #2563eb;
  color: #2563eb;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

.view-btn:hover {
  background: #eff6ff;
}

/* Badge */
.badge {
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
}
.badge.success { background: #dcfce7; color: #166534; }
.badge.warning { background: #fef9c3; color: #854d0e; }

/* Breakdown Modal */
.summary-cards {
    display: flex;
    gap: 15px;
    margin-bottom: 20px;
}

.card {
    background: #f3f4f6;
    padding: 15px;
    border-radius: 8px;
    flex: 1 1;
    display: flex;
    flex-direction: column;
}

.breakdown-table {
    width: 100%;
    border-collapse: collapse;
}

.breakdown-table th, .breakdown-table td {
    padding: 10px;
    border-bottom: 1px solid #eee;
    text-align: left;
}

.adjustment-row {
    background-color: #fffbeb;
}

.tag-adj {
    font-size: 10px;
    background: #f59e0b;
    color: white;
    padding: 2px 4px;
    border-radius: 4px;
    margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/GenerateSalaryComponent/PayRole/RunPayroll/RunPayroll.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;AACnB;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,cAAc,iBAAiB,EAAE;AACjC,eAAe,kBAAkB,EAAE;AACnC,YAAY,cAAc,EAAE;AAC5B,aAAa,gBAAgB,EAAE;;AAE/B;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;AACA,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;AACtD,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;;AAEtD,oBAAoB;AACpB;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,SAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".run-payroll-container {\n  padding: 10px;\n  background-color: #f8f9fa;\n  /* min-height: 100vh; */\n}\n\n.payroll-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  /* margin-bottom: 10px; */\n}\n\n.payroll-filters {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.filter-select {\n  padding: 3px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.primary-btn-payroll, .success-btn-payroll { \n    background-color: rgb(116, 197, 167);\n    color: white;\n    padding: 4px 16px;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    height: 30px;\n    margin-top: 3px;\n}\n\n.primary-btn-payroll:hover ,.success-btn-payroll:hover {\n  background-color: rgb(93, 159, 135);\n  color: black;\n}\n\n/* Table Styles */\n.payroll-table-wrapper {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n  overflow-x: auto;\n}\n\n.payroll-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.payroll-table th, .payroll-table td {\n  padding: 12px 16px;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n}\n\n.payroll-table th {\n  background-color: #f9fafb;\n  font-weight: 600;\n  color: #374151;\n}\n\n.text-right { text-align: right; }\n.text-center { text-align: center; }\n.text-red { color: #dc2626; }\n.font-bold { font-weight: 700; }\n\n.view-btn {\n  background: none;\n  border: 1px solid #2563eb;\n  color: #2563eb;\n  padding: 4px 8px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.view-btn:hover {\n  background: #eff6ff;\n}\n\n/* Badge */\n.badge {\n    padding: 2px 8px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 500;\n}\n.badge.success { background: #dcfce7; color: #166534; }\n.badge.warning { background: #fef9c3; color: #854d0e; }\n\n/* Breakdown Modal */\n.summary-cards {\n    display: flex;\n    gap: 15px;\n    margin-bottom: 20px;\n}\n\n.card {\n    background: #f3f4f6;\n    padding: 15px;\n    border-radius: 8px;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.breakdown-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.breakdown-table th, .breakdown-table td {\n    padding: 10px;\n    border-bottom: 1px solid #eee;\n    text-align: left;\n}\n\n.adjustment-row {\n    background-color: #fffbeb;\n}\n\n.tag-adj {\n    font-size: 10px;\n    background: #f59e0b;\n    color: white;\n    padding: 2px 4px;\n    border-radius: 4px;\n    margin-left: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
